<template>
    <component :is="layout">
        <h1 class="heading">Настройки</h1>
        <p>Раздел в разработке</p>
    </component>
</template>

<script>
  import SideBar from '../components/SideBar'
  import PageContent from '../components/PageContent'

  export default {
    name: 'Settings',
    data() {
      return {
        layout: 'default-layout'
      }
    },
    components: {
      PageContent,
      SideBar
    }
  }
</script>